import { useState, useEffect } from 'react';
import { UseModalDismissalProps } from '../interface/interface';

export const useModalDismissal = ({
  permanentlyDismissedKey,
  temporarilyDismissedKey,
  isLoading = false,
}: UseModalDismissalProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dontShowAgain, setDontShowAgain] = useState(false);
  const [hasLoadingCompleted, setHasLoadingCompleted] = useState(false);

  useEffect(() => {
    const modalPermanentlyDismissed = localStorage.getItem(
      permanentlyDismissedKey,
    );
    const modalTemporarilyDismissed = sessionStorage.getItem(
      temporarilyDismissedKey,
    );

    if (!modalPermanentlyDismissed && !modalTemporarilyDismissed) {
      // When loading transitions from true to false, show the modal
      if (!isLoading && !hasLoadingCompleted) {
        setIsModalOpen(true);
        setHasLoadingCompleted(true);
      }
    }
  }, [permanentlyDismissedKey, temporarilyDismissedKey, isLoading]);

  // Reset loading completion state when statrs again
  useEffect(() => {
    if (isLoading && hasLoadingCompleted) {
      console.log('🔄 Loading started again, resetting hasLoadingCompleted');
      setHasLoadingCompleted(false);
      setIsModalOpen(false);
    }
  }, [isLoading, hasLoadingCompleted]);

  const dismissModal = (permanent = false) => {
    if (permanent || dontShowAgain) {
      localStorage.setItem(permanentlyDismissedKey, 'true');
    } else {
      sessionStorage.setItem(temporarilyDismissedKey, 'true');
    }
    setIsModalOpen(false);
  };

  const closeModal = () => {
    if (dontShowAgain) {
      localStorage.setItem(permanentlyDismissedKey, 'true');
    } else {
      sessionStorage.setItem(temporarilyDismissedKey, 'true');
    }
    setIsModalOpen(false);
  };

  return {
    isModalOpen,
    setIsModalOpen,
    dontShowAgain,
    setDontShowAgain,
    dismissModal,
    closeModal,
  };
};
